import React from 'react';
import { cn } from '../utils';

export interface DrawerProps {
  id: string;
  side?: 'left' | 'right';
  overlay?: boolean;
  className?: string;
  children: React.ReactNode;
  sidebar: React.ReactNode;
}

export const Drawer: React.FC<DrawerProps> = ({
  id,
  side = 'left',
  overlay = true,
  className,
  children,
  sidebar,
}) => {
  return (
    <div className={cn('drawer', side === 'right' && 'drawer-end', className)}>
      <input id={id} type="checkbox" className="drawer-toggle" />
      <div className="drawer-content">{children}</div>
      <div className="drawer-side">
        {overlay && <label htmlFor={id} className="drawer-overlay"></label>}
        <div className="menu p-4 w-80 min-h-full bg-base-200 text-base-content">{sidebar}</div>
      </div>
    </div>
  );
};

export interface DrawerToggleProps {
  drawerId: string;
  className?: string;
  children: React.ReactNode;
}

export const DrawerToggle: React.FC<DrawerToggleProps> = ({ drawerId, className, children }) => {
  return (
    <label htmlFor={drawerId} className={cn('cursor-pointer', className)}>
      {children}
    </label>
  );
};
